import { render, staticRenderFns } from "./AnswersList.vue?vue&type=template&id=1e02ccbc"
import script from "./AnswersList.vue?vue&type=script&lang=js"
export * from "./AnswersList.vue?vue&type=script&lang=js"
import style0 from "./AnswersList.vue?vue&type=style&index=0&id=1e02ccbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports